import React, { useEffect, useState, useMemo } from 'react';
import { Select } from 'antd';
import { apiqueryVisitHistory } from '../../../shared/api';
// import $ from 'jquery';
import { htmltoStr } from '../../../../utils';
import { Pager } from '@portal-site/pager';
import usePage from '../../../components/Hooks/usePage';
import { Link } from 'react-router-dom';
import Loading from '../../../components/Loading';
import Default from '@/assets/images/desktop/common/default.jpg';
const pre = window.ENV_IMG_PREURL_SRC;

const Track = () => {
  const { Option } = Select;
  const [data, setData] = useState();
  const [time, setTime] = useState('0');
  const [loading, setloading] = useState(true);
  const [initPage, setPage] = usePage(1);

  function handleChange(value) {
    setTime(value);
  }

  // const [initPage, setPage] = usePage(search.split('page=')[1]);
  const params = useMemo(() => {
    return {
      current: initPage,
      size: 8,
      timeDistance: time,// 0 近一周 ； 1 近半个月 ； 2 近一个月
    }
  }, [time, initPage])

  useEffect(() => {
    getData(params);
  }, [params]);

  const getData = (param) => {
    setloading(true)
    apiqueryVisitHistory(param).then((res) => {
      setloading(false)
      if(res.records){
        res.records.forEach(el => {
          if(el.instanceModel && el.instanceModel.files.length>0){
            el['showImage'] = pre +'/'+ el.instanceModel.files[0].fileThumbnail;
          }
          if(el.startNodeName && el.endNodeName){
            el['operationName'] = '关系图谱';
            el['name'] = el.startNodeName+'和'+el.endNodeName+'的关系路径';
            el['path'] = '/Relation?startsearch='+el.startNodeName+'&endsearch='+el.endNodeName;
          }else{
            if(el.fileInfoId){
              el['operationName'] = '影像探索';
              el['name'] = el.instanceModel?.instanceName;
              el['path'] = '/PicturelistPage/'+el.instanceModel?.instanceId+'?fileInfoId='+el.fileInfoId;
            }else{
              el['operationName'] = '知识百科';
              el['name'] = el.instanceModel?.instanceName;
              el['path'] = '/Subject/'+el.instanceModel?.conceptCode+'/'+el.instanceModel?.instanceId;
            }
          }
        })
      }
      setData(res);
    });
  }


  // eslint-disable-next-line no-unused-vars
  // function confirm(id, relationId) {
  //   apiDelCollection(relationId).then((res) => {
  //     if (res.data) {
  //       $(id).remove();
  //       message.success('取消收藏成功');
  //     } else {
  //       message.error('取消收藏失败')
  //     }
  //   });
  // }

  return (
    <div className="personal-common">
      <div className='p-head'>
        <div className="p-title">浏览记录</div>
        <div className="topbar">
          <Select defaultValue="0" style={{ width: 130 }} onChange={handleChange}>
            <Option value="">全部</Option>
            <Option value="0">近一周</Option>
            <Option value="1">近半个月</Option>
            <Option value="2">近一个月</Option>
          </Select>
        </div>
      </div>
      <div className="collection-box">
        <section className="collection-img">
          {
            loading ? <Loading /> : data?.records?.map((item, index) => {
              return (
                <Link to={item.path} target="_blank" className="collection-item" key={index}>
                  <div className="item-l">
                    <img src={item.showImage ? item.showImage : Default}/>
                  </div>
                  <div className='item-r'>
                    <p className='title'>
                      <span title={item.name}>{item.name}</span>
                      <span>{item.operationName}</span>
                    </p>
                    <p className='time'>{item.createTime}</p>
                  </div>
                </Link>
              )
            })
          }
          <div className='clearfix'/>
        </section>
        {data?.total > 1 && (
          <Pager
            containerClassName="mypager"
            forcePage={initPage || 1}
            pageCount={data?.pages}
            // total={data?.total}
            onPageChange={(page) => setPage(page)}
            // showLast={false}
            // showFirst={false}
            prevLabel="上一页"
            nextLabel="下一页"
          // showTotal
          />
        )}
        {data && data?.total === 0 && <div className="collection-empty">
          <div className="img" />
          <p>暂无浏览记录</p>
          <Link to="/">再去看看吧~</Link>
        </div>}
      </div>
    </div>
  )
}

export default Track;
